import type { Discount } from "@/models/discount";

/**
 * Redux partial payloads for manual discount selection.
 */
export type DiscountSelectionPatch = {
  selected: Discount;
};

/** Apply or clear the customer-chosen offer. */
export function manualSelectDiscount(offer: Discount | null): DiscountSelectionPatch {
  return {
    selected: offer && offer.discount_id ? offer : ({} as Discount),
  };
}

/** Clear selection (e.g. clear cart). */
export function resetDiscountSelection(): DiscountSelectionPatch {
  return {
    selected: {} as Discount,
  };
}
